import { Component, forwardRef, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteCompleteEvent, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { Subject } from 'rxjs';
import { PpmOffice } from 'src/app/api/commonInterfaces';

@Component({
  selector: 'app-office-dropdown',
  templateUrl: './office-dropdown.component.html',
  styleUrls: ['./office-dropdown.component.scss'],
  imports: [AutoCompleteModule, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OfficeDropdownComponent),
      multi: true
    }
  ],
})
export class OfficeDropdownComponent {
  constructor() { }

  onChange: any = () => { };
  onTouched: any = () => { };
  disabled = false;

  selectedOffice: PpmOffice | undefined;
  selectedValue: number | null | undefined
  dropdownItems: PpmOffice[] = []

  private _offices: PpmOffice[] = [];
  @Input() set offices(value: PpmOffice[]) {

    this._offices = [...value].sort((a, b) => a.name.localeCompare(b.name))
    this.dropdownItems = this._offices

    this.selectedOffice = this.dropdownItems.find(o => o.id === this.selectedValue)
  }

  get offices(): PpmOffice[] {
    return this._offices;
  }


  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


  writeValue(value: number | string): void {
    if (typeof value === "string") value = Number.parseInt(value, 10)

    this.selectedValue = value;
    this.selectedOffice = this.dropdownItems.find(o => o.id === value)



  }

  search(event: AutoCompleteCompleteEvent) {
    if (!event.query) {
      this.dropdownItems = [...this.offices]
    } else {
      this.dropdownItems = this.offices.filter(l => l.name.toLowerCase().includes(event.query.toLowerCase()))
    }
  }

  onOfficeSelected(event: AutoCompleteSelectEvent) {
    this.onChange(event.value.id)
  }

  onOfficeCleared() {
    this.selectedOffice = undefined
    this.onChange(null)
  }
}
